import { useRef, useEffect } from 'react';

var useOutsideClick = function useOutsideClick(callback) {
  var ref = useRef(null);
  var handleClickOutside = function handleClickOutside(event) {
    if (ref.current && typeof callback === 'function') {
      var path = event.composedPath();
      var isPartOfSVG = path.some(function (element) {
        return element instanceof SVGElement;
      });
      if (!isPartOfSVG && !ref.current.contains(event.target)) {
        callback(event);
      } else if (isPartOfSVG && !path.includes(ref.current)) {
        callback(event);
      }
    }
  };
  useEffect(function () {
    var timeoutId = setTimeout(function () {
      document.addEventListener('click', handleClickOutside);
    });
    return function () {
      clearTimeout(timeoutId);
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  return ref;
};

export { useOutsideClick as default, useOutsideClick };
//# sourceMappingURL=useOutsideClick.js.map
